import { createSlice } from '@reduxjs/toolkit';

const initialTargetingLanguagesState = { type: 'all_languages' };

const targetingLanguagesSlice = createSlice({
  name: 'targetingLanguages',
  initialState: initialTargetingLanguagesState,
  reducers: {
    changeLanguagesTargetingType: (state, action) => {
      state.type = action.payload;
    },
    restoreInitialState: () => initialTargetingLanguagesState,
  },
});

export const targetingLanguagesActions = targetingLanguagesSlice.actions;
export default targetingLanguagesSlice.reducer;
